import CitySEOHead from "@/components/feature/CitySEOHead";
import ColumbiaHeroSection from "./components/HeroSection";
import ColumbiaStickyNav from "./components/StickyNav";
import ColumbiaProcessingTimeSection from "./components/ProcessingTimeSection";
import ColumbiaFAQSection, { faqs } from "./components/FAQSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityTravelTimingSection from "@/pages/city-template/components/CityTravelTimingSection";
import CityDestinationsSection from "@/pages/city-template/components/CityDestinationsSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { columbiaTnConfig } from "./data";

export default function ColumbiaTnPage() {
  const c = columbiaTnConfig;
  return (
    <>
      <CitySEOHead
        city="Columbia"
        state="Tennessee"
        stateAbbr="TN"
        route="/columbia-tn"
        title="Emergency Passport Columbia, TN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Columbia, TN — as fast as 24 hours. A+ BBB rated registered courier serving Columbia State, Maury County, and all South Middle Tennessee. No Nashville drive required."
        geoPlacename="Columbia, Tennessee"
        geoPosition="35.6151;-87.0358"
        faqs={faqs}
        servicesSchema={c.servicesSchema}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
      />
      <div className="font-sans">
        <ColumbiaHeroSection />
        <ColumbiaStickyNav />
        <ColumbiaProcessingTimeSection />
        <CityServicesSection city={c.city} services={c.services} intro={c.servicesIntro} />
        <CityLocalAreaSection city={c.city} state={c.state} cities={c.nearbyCitiesZips} benefits={c.benefits} internalLinks={c.internalLinks} officeNote={c.fpcOfficeNote} officeDistance={c.fpcOfficeDistance} officeAddress={c.fpcOfficeAddress} serviceAreaIntro={c.serviceAreaIntro} nearbyCitiesIntro={c.nearbyCitiesIntro} />
        {c.travelTiming && <CityTravelTimingSection city={c.city} data={c.travelTiming} />}
        {c.destinations && <CityDestinationsSection city={c.city} data={c.destinations} />}
        <CityTestimonialsSection city={c.city} testimonials={c.testimonials} intro={c.testimonialsIntro} />
        <CityAcceptanceFacilitiesSection city={c.city} facilities={c.facilities} />
        <CityComparisonSection city={c.city} regionalAgency={c.regionalAgency} rows={c.comparisonRows} />
        <CityMistakesSection city={c.city} mistakes={c.mistakes} intro={c.mistakesIntro} />
        <CityHowItWorksSection city={c.city} steps={c.steps} intro={c.howItWorksIntro} />
        <ColumbiaFAQSection />
        <CityHelpfulResourcesSection city={c.city} state={c.state} photoLocations={c.photoLocations} dmvLocations={c.dmvLocations} airports={c.airports} dmvWebsite={c.dmvWebsite} dmvLabel={c.dmvLabel} vitalRecordsLinks={c.vitalRecordsLinks} />
        <SEOCrossLinks currentRoute="/cities/columbia-tn" state="TN" />
        <CityFinalCTA />
      </div>
    </>
  );
}